module.exports = __webpack_public_path__ + "static/anh_2-d7d5bae48181fa2aa140c25c3ded8202.jpg";